import gql from "graphql-tag";

export const ZIP_CODE_TAX_RATES = gql `
  query ListZipCodeTaxRates(
    $skip: Int!
    $take: Int!
    ) {
    zipCodeTaxRates(
      skip: $skip
      take: $take
      ) {
        items {
            zipCode
            state
            combinedRate
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
    }
}
`

export const GET_TAX_RATE = gql`
 query GetZipCodeTaxRate($zipCode: String!, $state: String!) {
  zipCodeTaxRates(
    where: { and: [{ zipCode: { eq: $zipCode } }, { state: { eq: $state } }] }
  ) { 
    items {
      zipCode
      state
      combinedRate
    }
  }
}
`